import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { RequireAuth } from "@/features/auth";

const ProfilePage = lazyWithRetry(() => import("./pages/ProfilePage"));

const routes: RouteObject[] = [
  {
    Component: RequireAuth,
    children: [{ path: "/profile", Component: ProfilePage }],
  },
];

export default routes;
